module.exports = __webpack_public_path__ + "img/apt-1@2x.68e0c59a.jpg";